module.exports = __webpack_public_path__ + "static/007-40c058b2f92cd9751035368cc1e32d8e.jpg";